import { clearRecent } from "./recent.js";
const SHARED_API_URL = "https://api.g1.network";
const AUTH_URL = "https://auth.g1.network";
const TAXONOMY_DOCS = "https://github.com/TheG1Team/platform/blob/main/docs/DOMAIN-TAXONOMY.md";
/**
 * Default commands available in every launcher. Triggered by typing `>` in
 * the input. Consumers can append app-specific commands via the `commands`
 * prop on UniversalLauncher.
 */
export const DEFAULT_COMMANDS = [
    {
        id: "sign-out",
        label: "Sign out",
        hint: "End the current session",
        action: async () => {
            try {
                await fetch(`${SHARED_API_URL}/auth/logout`, {
                    method: "POST",
                    credentials: "include",
                });
            }
            catch {
                // best-effort; cookie may already be invalidated
            }
            const ret = encodeURIComponent(`${window.location.origin}/`);
            window.location.replace(`${AUTH_URL}/?return=${ret}`);
        },
    },
    {
        id: "open-mcp-gateway",
        label: "Open MCP Gateway",
        hint: "https://mcp.g1.network/mcp",
        action: () => {
            window.location.href = "https://mcp.g1.network";
        },
    },
    {
        id: "open-taxonomy-docs",
        label: "Open Domain Taxonomy docs",
        hint: TAXONOMY_DOCS,
        action: () => {
            window.open(TAXONOMY_DOCS, "_blank", "noopener,noreferrer");
        },
    },
    {
        id: "clear-recent-apps",
        label: "Clear recent apps",
        hint: "Reset launcher frecency tracker",
        action: () => {
            clearRecent();
        },
    },
];
//# sourceMappingURL=commands.js.map